import React from 'react';
import closeIcon from "../assets/close-icon.png";
import './SettingsModal.css'; 

const SettingsModal = ({ isOpen, onClose, onToggleDarkMode, isDarkMode }) => {
  if (!isOpen) return null; 

  return (
    <div className={`modal-overlay ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="modal-content">
       <div className="modal-header">
       <h2>Settings</h2>
        <img 
        onClick={onClose}
                src={closeIcon} 
                alt="Settings"
                className="profile-icon"/>
       </div>
        <div className="toggle-container">onToggleDarkMode
          <label>
            Dark Mode
          </label>

          <input
              type="checkbox"
              checked={isDarkMode}
              onChange={onToggleDarkMode}
              className="theme-checkbox"
            />
        </div>
      </div>
    </div>
  );
};

export default SettingsModal; 